import React, { createContext, useContext, useEffect } from 'react';

const TokenExpiryContext = createContext();

export function useTokenExpiry() {
    return useContext(TokenExpiryContext);
}

const TOKEN_KEY = 'token'; // Change if your token key is different
const LOGIN_TIMESTAMP_KEY = 'loginTimestamp';
const EXPIRY_MINUTES = 60;

function clearAuthAndReload() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(LOGIN_TIMESTAMP_KEY);
    // Add any other keys you use for auth here
    window.location.href = '/'; // Or your login route
}

export function TokenExpiryProvider({ children }) {
    useEffect(() => {
        const loginTimestamp = localStorage.getItem(LOGIN_TIMESTAMP_KEY);
        if (loginTimestamp) {
            const now = Date.now();
            const elapsed = now - parseInt(loginTimestamp, 10);
            const expiryMs = EXPIRY_MINUTES * 60 * 1000;
            if (elapsed >= expiryMs) {
                clearAuthAndReload();
            } else {
                const timeout = setTimeout(clearAuthAndReload, expiryMs - elapsed);
                return () => clearTimeout(timeout);
            }
        }
    }, []);

    // Provide a function to set login timestamp on login
    const setLoginTimestamp = () => {
        localStorage.setItem(LOGIN_TIMESTAMP_KEY, Date.now().toString());
    };

    return (
        <TokenExpiryContext.Provider value={{ setLoginTimestamp }}>
            {children}
        </TokenExpiryContext.Provider>
    );
} 